var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.5,
    height: 35.103,
    viewBox: "0 0 37.5 35.103",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(816.939 -502.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "translate(-815.689 503.884)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 4.538,
    transform: "translate(30.462 3.727)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 16.222,
    transform: "translate(0 3.727)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M-792.446,507.61a3.725,3.725,0,0,1-3.725,3.727,3.725,3.725,0,0,1-3.726-3.727,3.727,3.727,0,0,1,3.726-3.727A3.727,3.727,0,0,1-792.446,507.61Z",
    transform: "translate(822.642 -503.884)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(-815.689 529.034)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 8.742,
    transform: "translate(26.258 3.727)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 12.23,
    transform: "translate(0 3.727)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M-795.6,525.3a3.726,3.726,0,0,1-3.727,3.726,3.727,3.727,0,0,1-3.726-3.726,3.727,3.727,0,0,1,3.726-3.727A3.726,3.726,0,0,1-795.6,525.3Z",
    transform: "translate(820.994 -521.572)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(-815.689 516.461)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x1: 4.695,
    transform: "translate(0 3.725)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x1: 15.719,
    transform: "translate(19.281 3.725)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M-811.962,516.454a3.726,3.726,0,0,1,3.726-3.725,3.725,3.725,0,0,1,3.726,3.725,3.726,3.726,0,0,1-3.726,3.727A3.727,3.727,0,0,1-811.962,516.454Z",
    transform: "translate(816.922 -512.729)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/User.c5fe416a.svg";
export { ForwardRef as ReactComponent };